import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	noOrgDisplayTitle: {
		id: 'fastshift.dashboard.no-org-display.title',
		defaultMessage: 'You’re viewing tickets that aren’t associated with any cloud organization',
		description: 'Title for the no org display',
	},
	noOrgDisplayDescription: {
		id: 'fastshift.dashboard.no-org-display.description',
		defaultMessage:
			'Tickets linked to an existing cloud organization appear under that organization’s name. Once linked, you’ll find the ticket in its respective view.',
		description: 'Description for the no org display',
	},
});
